import { VISIBLE_TIME_OUT } from "@/components/constants";
import { hideConfirm, resetConfirm } from "@/redux/confirm/ConfirmSlice";

/**
 * confirm 닫기 처리
 * - visible false 처리 후 일정 시간 뒤 데이터 초기화
 * @returns {Function} Redux thunk 함수
 */

export const clearConfirm = () => (dispatch) => {
    dispatch(hideConfirm());
    setTimeout(() => {
        dispatch(resetConfirm());
    }, VISIBLE_TIME_OUT);
};